export class ProductStructList {
    productList = []
}
